/* Shared Velantis catalog matching. No network request; cached normalized fields. R54. */
(function(w){'use strict';
 var fields=new Map(),queries=new Map();
 function plain(s){return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}
 function norm(s){return plain(s).replace(/[^a-z0-9]/g,'');}
 function words(s){return plain(s).split(/[^a-z0-9]+/).filter(Boolean);}
 function keep(map,k,v,max){if(map.size>=max)map.delete(map.keys().next().value);map.set(k,v);return v;}
 // Banded optimal-string-alignment distance; adjacent swapped letters count once.
 function distance(a,b,max){
  if(a===b)return 0;if(Math.abs(a.length-b.length)>max)return max+1;
  var prev=Array.from({length:b.length+1},function(_,i){return i;}),prev2=null;
  for(var i=1;i<=a.length;i++){
   var row=new Array(b.length+1).fill(max+1);row[0]=i;var lo=Math.max(1,i-max),hi=Math.min(b.length,i+max);
   for(var j=lo;j<=hi;j++){
    row[j]=Math.min(prev[j]+1,row[j-1]+1,prev[j-1]+(a[i-1]===b[j-1]?0:1));
    if(prev2&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1])row[j]=Math.min(row[j],prev2[j-2]+1);
   }prev2=prev;prev=row;
  }return prev[b.length];
 }
 function score(q,n){if(!q||!n)return 0;if(n===q)return 1000;if(n.indexOf(q)===0)return 900;if(n.indexOf(q)>=0)return 800;if(q.length<4)return 0;var max=Math.min(3,Math.floor(q.length*.28));if(Math.abs(n.length-q.length)>max)return 0;var d=distance(q,n,max);return d<=max?600-d*50:0;}
 function compile(q){var raw=String(q||'');return queries.get(raw)||keep(queries,raw,{q:norm(raw),words:words(raw),results:new Map(),wordMatches:new Map()},32);}
 function entry(item){var key=JSON.stringify([item.sku||'',item.nombre||'',item.casa||'',item.texto||'',item.kind||'']);var e=fields.get(key);if(e)return e;
  e={key:key,kind:norm(item.kind),sku:norm(item.sku),name:norm(item.nombre),house:norm(item.casa),text:norm([item.sku,item.nombre,item.casa,item.texto].join(' ')),words:Array.from(new Set(words([item.nombre,item.casa,item.texto].join(' '))))};return keep(fields,key,e,6000);
 }
 function match(query,item){var c=compile(query),q=c.q;if(!q)return 0;var e=entry(item);if(c.results.has(e.key))return c.results.get(e.key);var s=0;
  if(/^(?:v|ar|a|d|df)\d+$/.test(q)){var code=q.match(/^([a-z]+)(\d+)$/);q=code[1]+code[2].padStart(3,'0');s=e.sku===q?1100:e.sku.indexOf(q)===0?900:0;}
  else if(/^(?:ambiental(?:es)?|aromatizantes?)$/.test(q)){s=e.kind==='ambiental'||e.house==='aromatizantes'?1000:0;}
  else{
   s=Math.max(score(q,e.name),Math.round(score(q,e.house)*.9));
   if(e.text.indexOf(q)>=0)s=Math.max(s,700);
   if(c.words.length>1&&c.words.every(function(v){return e.text.indexOf(v)>=0;}))s=Math.max(s,650);
   // Whole-name matches keep priority. Word-level tolerance also works on notes.
   if(s<500&&c.words.length&&c.words.every(function(v){
    if(e.text.indexOf(v)>=0)return true;if(v.length<4||/^\d+$/.test(v))return false;
    var max=v.length>=7?2:1;return e.words.some(function(t){if(Math.abs(v.length-t.length)>max)return false;var key=v+'|'+t;if(c.wordMatches.has(key))return c.wordMatches.get(key);var ok=distance(v,t,max)<=max;c.wordMatches.set(key,ok);return ok;});
   }))s=Math.max(s,500);
  }
  c.results.set(e.key,s);return s;
 }
 w.VelantisBusqueda={version:'63',normalizar:norm,puntuar:function(q,v){return score(norm(q),norm(v));},coincidencia:match};
})(window);
